import React from 'react';
import {
  Container,
  Typography,
  Box,
  Paper,
  Divider,
} from '@mui/material';
import TableOrderLayout from '../../components/user/TableOrderLayout';

const TermsPage = () => {
  return (
    <TableOrderLayout 
      title="Terms and Conditions" 
      subtitle="Please read our terms and conditions carefully"
      showBackButton={true}
      showCart={false}
    >
      <Container maxWidth="md" sx={{ py: { xs: 2, sm: 3, md: 4 } }}>
        <Paper elevation={2} sx={{ p: { xs: 2, sm: 3, md: 4 } }}>
          <Typography 
            variant="h4" 
            fontWeight="bold" 
            gutterBottom
            sx={{ fontSize: { xs: '1.5rem', sm: '2rem', md: '2.5rem' } }}
          >
            Terms and Conditions
          </Typography>
          <Typography 
            variant="body2" 
            color="text.secondary" 
            gutterBottom
            sx={{ fontSize: { xs: '0.75rem', sm: '0.875rem' } }}
          >
            Last updated: {new Date().toLocaleDateString()}
          </Typography>
          
          <Divider sx={{ my: 3 }} />

          <Box sx={{ '& > *': { mb: { xs: 2, sm: 3 } } }}>
            {[
              {
                title: "1. Acceptance of Terms",
                content: "By accessing and using this restaurant website and services, you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service."
              },
              {
                title: "2. Use License",
                content: "Permission is granted to temporarily download one copy of the materials on our website for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:",
                list: [
                  "modify or copy the materials",
                  "use the materials for any commercial purpose or for any public display",
                  "attempt to reverse engineer any software contained on the website",
                  "remove any copyright or other proprietary notations from the materials"
                ]
              },
              {
                title: "3. Food Orders and Reservations",
                content: "All food orders and table reservations are subject to availability. We reserve the right to refuse service to anyone for any reason at any time. Prices and menu items are subject to change without notice.",
                additional: "For reservations, please arrive on time. We may release your table if you are more than 15 minutes late without prior notice."
              }
            ].map((section, index) => (
              <Box key={index}>
                <Typography 
                  variant="h6" 
                  fontWeight="bold" 
                  gutterBottom
                  sx={{ fontSize: { xs: '1rem', sm: '1.25rem' } }}
                >
                  {section.title}
                </Typography>
                <Typography 
                  variant="body2" 
                  paragraph
                  sx={{ fontSize: { xs: '0.875rem', sm: '1rem' } }}
                >
                  {section.content}
                </Typography>
                {section.list && (
                  <Typography 
                    variant="body2" 
                    component="ul" 
                    sx={{ 
                      pl: { xs: 2, sm: 3 },
                      fontSize: { xs: '0.875rem', sm: '1rem' }
                    }}
                  >
                    {section.list.map((item, idx) => (
                      <li key={idx}>{item}</li>
                    ))}
                  </Typography>
                )}
                {section.additional && (
                  <Typography 
                    variant="body2" 
                    paragraph
                    sx={{ fontSize: { xs: '0.875rem', sm: '1rem' } }}
                  >
                    {section.additional}
                  </Typography>
                )}
              </Box>
            ))}

            {[
              {
                title: "4. Payment Terms",
                content: "Payment is due at the time of service unless otherwise arranged. We accept cash, credit cards, and other approved payment methods. All prices are subject to applicable taxes and service charges."
              },
              {
                title: "5. Cancellation Policy",
                content: "Reservations may be cancelled up to 2 hours before the scheduled time without penalty. Cancellations made less than 2 hours before the scheduled time may be subject to a cancellation fee."
              },
              {
                title: "6. Privacy Policy",
                content: "Your privacy is important to us. Please review our Privacy Policy, which also governs your use of the website, to understand our practices."
              },
              {
                title: "7. Limitation of Liability",
                content: "In no event shall our restaurant or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on our website, even if we or our authorized representative has been notified orally or in writing of the possibility of such damage."
              },
              {
                title: "8. Accuracy of Materials",
                content: "The materials appearing on our website could include technical, typographical, or photographic errors. We do not warrant that any of the materials on its website are accurate, complete, or current. We may make changes to the materials contained on its website at any time without notice."
              },
              {
                title: "9. Modifications",
                content: "We may revise these terms of service for its website at any time without notice. By using this website, you are agreeing to be bound by the then current version of these terms of service."
              },
              {
                title: "10. Contact Information",
                content: "If you have any questions about these Terms and Conditions, please contact us at:",
                additional: "Email: info@restaurant.com\nPhone: +1 (555) 123-4567\nAddress: 123 Main Street, City, State 12345"
              }
            ].map((section, index) => (
              <Box key={index + 3}>
                <Typography 
                  variant="h6" 
                  fontWeight="bold" 
                  gutterBottom
                  sx={{ fontSize: { xs: '1rem', sm: '1.25rem' } }}
                >
                  {section.title}
                </Typography>
                <Typography 
                  variant="body2" 
                  paragraph
                  sx={{ fontSize: { xs: '0.875rem', sm: '1rem' } }}
                >
                  {section.content}
                </Typography>
                {section.additional && (
                  <Typography 
                    variant="body2"
                    sx={{ 
                      fontSize: { xs: '0.875rem', sm: '1rem' },
                      whiteSpace: 'pre-line'
                    }}
                  >
                    {section.additional}
                  </Typography>
                )}
              </Box>
            ))}
          </Box>
        </Paper>
      </Container>
    </TableOrderLayout>
  );
};

export default TermsPage;
